export const userRoleMapper = {
  admin: 'Administrador',
  worker: 'Funcionário',
  customer: 'Cliente'
};

export const userRoleOptions = [
  { label: 'Administrador', value: 'admin' },
  { label: 'Funcionário', value: 'worker' },
  { label: 'Cliente', value: 'customer' },
];

export const resourceCategoryMapper = {
  web_gis: 'WebGis',
  point_cloud: 'Nuvem de Pontos'
};

export const resourceCategoryOptions = [
  { label: 'WebGis', value: 'web_gis' },
  { label: 'Nuvem de Pontos', value: 'point_cloud' }
];